// extracted by mini-css-extract-plugin
export default {"wrap":"Comments_wrap__dxb6M","green":"Comments_green__EvtAl"};